











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.DestroyUserCommand')
    
    export class DestroyUserCommand {
        constructor( userIdToDestroy: number ) {
            
                this.userIdToDestroy = userIdToDestroy;
            
        }

        
            public userIdToDestroy: number;
        
    }

    export interface IDestroyUserCommand {
        
            userIdToDestroy: number;
        
    }

    export async function destroyUser( command: DestroyUserCommand ): Promise<CommandResult<void>>
    export async function destroyUser( { userIdToDestroy }: IDestroyUserCommand ): Promise<CommandResult<void>>
    export async function destroyUser( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof DestroyUserCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new DestroyUserCommand( model['userIdToDestroy'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace DestroyUserCommand.ExtraneousTypes {
        

        
    }

